import React, { useState } from 'react'
import '../Styles/login.css'
import Service from '../utility/Service';
import dashboardimg from '../shared/assets/images/dashboardimg.jpg'
const service = new Service();


const Login = () => {


	const [userName, setUserName] = useState("");
	const [passwords, setPassword] = useState("");

	const userNameInput = (e) => {
		const name = e.target.value;
		setUserName(name);
	}

	const userPassInput = (e) => {
		const password = e.target.value
		setPassword(password)
	}

	const handleSubmit = (e) => {

		e.preventDefault();
		let email = userName
		let password = passwords
		if (email !== '' && password !== '') {
			let postData = {
				"email": email,
				"password": password
			}
			let url = global.appUrl + '/adminlogin'
			service.postServiceCall(url, postData).then((json) => {
                console.log(json, "json");
				if (json.message === "success") {
					if (json.data && json.data.email) {
						localStorage.setItem('username', json.data.username)
						localStorage.setItem('email', json.data.email);
						localStorage.setItem('appToken', json.token)
						window.location.href = ('/dashboard');
					} else {
						document.getElementsByClassName('error-email')[0].style.display = "block";
					}
				} else {
					localStorage.setItem('appToken', '');
					localStorage.setItem('email', '');
					document.getElementsByClassName('error-email')[0].style.display = "block";
				}
			}).catch((error) => {
				console.error(error);
			});
		}
	}
	return (
		<>
			<div className="container">
				<div className="img">
					<img src={dashboardimg} alt='dashboard' />
{/* <h1>JKmars Finance</h1> */}
				</div>
				<div className="login-content">
					<form >
						<img src="https://raw.githubusercontent.com/sefyudem/Responsive-Login-Form/master/img/avatar.svg" />
						<h3 className="title">Welcome</h3>
						<div className="input-div one">
							<div className="i">
								<i className="fas fa-user"></i>
							</div>
							<div className="div">
								<input type="text" className="input" placeholder='Username' onChange={(e) => userNameInput(e)} />
							</div>
						</div>
						<div className="input-div pass">
							<div className="i">
								<i className="fas fa-lock"></i>
							</div>
							<div className="div">
								<input type="password" className="input" placeholder='Password' onChange={(e) => userPassInput(e)} />
							</div>
						</div>
						<p className="error-email" id="errorEmail"> Please enter correct user id and password </p>
						<button type="submit" className="loginbtn" onClick={(e) => handleSubmit(e)}><a >Login</a></button>
					</form>
				</div>
			</div>
		</>
	)
}

export default Login
